import { useNavigate } from 'react-router-dom'
import { Button } from '@material-ui/core'

const BackButton = () => {
    const navigate = useNavigate()
    return (
        <Button
            style={{ backgroundColor: 'antiquewhite', marginBottom: '30px' }}
            variant="text"
            color="inherit"
            onClick={() => navigate('/bogota')}
            sx={{
                textTransform: 'none',
                fontWeight: 'bold',
                mb: 2
            }}
        >
            Back
        </Button>
    )
}

export default BackButton;
